// extracted by mini-css-extract-plugin
module.exports = {"actions":"UserFormActions_actions__3zdA9","btn__cancel":"UserFormActions_btn__cancel__3K5NZ"};